/**
 * Types for SystemRuleGroup maintenance
 */

export interface SystemRuleGroupMaintenanceDto {
  id: number;
  companyNo: string;
  ruleGroupID: number;
  lng1: string;  // Norwegian name
  lng2: string | null;  // English name
  activeYesNo: boolean;
  createdBy: string | null;
  created: string | null;
  updatedBy: string | null;
  lastUpdate: string | null;
  ruleCount: number;  // Number of associated rules
}

export interface CreateSystemRuleGroupRequest {
  lng1: string;
  lng2?: string;
  activeYesNo: boolean;
}

export interface UpdateSystemRuleGroupRequest {
  lng1: string;
  lng2?: string;
  activeYesNo: boolean;
}

// UI State types
export interface SystemRuleGroupFormData {
  lng1: string;
  lng2: string;
  activeYesNo: boolean;
}

export const emptyFormData: SystemRuleGroupFormData = {
  lng1: '',
  lng2: '',
  activeYesNo: true,
};
